import { shopifyRequest } from '.'

interface AddCartLinesVariables {
  cartId: string,
  lines: any[]
}

const addCartLines = async (variables: AddCartLinesVariables, silent = true) => {
  const result = await shopifyRequest(`
    mutation addCartLines($cartId: ID!, $lines: [CartLineInput!]!) {
      cartLinesAdd(cartId: $cartId, lines: $lines) {
        cart {
          id
          checkoutUrl
          lines(first: 10) {
            edges {
              node {
                id
                quantity
                merchandise {
                  ... on ProductVariant {
                    id
                    title
                    quantityAvailable
                    product {
                      id
                      title
                    }
                    image {
                      id
                      src
                    }
                    priceV2 {
                      amount
                      currencyCode
                    }
                  }
                }
                estimatedCost {
                  subtotalAmount {
                    amount
                    currencyCode
                  }
                  totalAmount {
                    amount
                    currencyCode
                  }
                }
                attributes {
                  key
                  value
                }
              }
            }
          }
          estimatedCost {
            subtotalAmount {
              amount
              currencyCode
            }
          }
        }
        userErrors {
          field
          message
        }
      }
    }
  `, variables, silent)

  return result.cartLinesAdd
}

export default addCartLines